// src/components/admin/FloatingCCPButton.tsx
// Botón flotante para abrir/cerrar el CCP embebido en la aplicación
// Posición: encima del botón de chat (mismo eje, no superpone contenido)

import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faTimes } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';

interface FloatingCCPButtonProps {
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
}

const FloatingCCPButton = ({ isOpen, onToggle }: FloatingCCPButtonProps) => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  if (!isHome) {
    return null;
  }

  return (
    <motion.button
      onClick={() => onToggle(!isOpen)}
      className="fixed bottom-[208px] right-4 sm:bottom-[210px] sm:right-6 z-[45] flex items-center justify-center w-14 h-14 bg-green-600 hover:bg-green-700 active:bg-green-800 text-white rounded-full shadow-xl hover:shadow-2xl transition-all duration-200 group ring-4 ring-green-500/20 hover:ring-green-500/40 touch-manipulation"
      aria-label={isOpen ? 'Close Agent Panel' : 'Open Agent Panel'}
      title={isOpen ? 'Close Agent Panel' : 'Open Agent Panel'}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <FontAwesomeIcon icon={isOpen ? faTimes : faPhone} className="w-6 h-6" />
      <div className="absolute right-full top-1/2 -translate-y-1/2 mr-2 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap bg-gray-900 text-white text-xs rounded-lg px-3 py-2 pointer-events-none">
        {isOpen ? 'Close Panel' : 'Agent Panel'}
        <span className="absolute top-1/2 -right-1 -translate-y-1/2 border-4 border-transparent border-l-gray-900" />
      </div>
    </motion.button>
  );
};

export default FloatingCCPButton;
